module.exports = __webpack_public_path__ + "img/login.71119031.svg";